class ScrollBtn {
    constructor() {
        this.scrollBtns = document.querySelectorAll('.scroll-top-btn');
        this.btnIsActive = false;
        
        if(this.scrollBtns) {
            this.scrollBtns.forEach(scrollBtn => {
                this.event(scrollBtn);
            })
        }
    }
    
    // ============
    // Events
    // =============
    event(scrollBtn) {
        window.addEventListener('scroll', () => this.scrollBtnHandler(scrollBtn));
        window.addEventListener('resize', () => this.scrollBtnHandler(scrollBtn));
        scrollBtn.addEventListener('click', () => this.handleBtnCLick());
    }

    // ============
    // Methods
    // =============

    // 全ての処理
    scrollBtnHandler(scrollBtn) {
        this.showScrollBtn(scrollBtn);
        this.handleBtnActivation(scrollBtn);
    }

    // ボタンの表示/非表示
    showScrollBtn(scrollBtn) {
        if(window.scrollY > 500) {
            scrollBtn.classList.add('is-visible');
        }else {
            scrollBtn.classList.remove('is-visible');
            this.btnIsActive = false;
        }
    }

    // ボタンのクリックしてからスクロールが終わるまでの処理
    handleBtnActivation(scrollBtn) {
        if(this.btnIsActive) {
            scrollBtn.classList.add('is-active');
        }else {
            scrollBtn.classList.remove('is-active');
        }
    }

    // ボタンクリックの処理
    handleBtnCLick() {
        this.btnIsActive = true;
        window.scrollTo(0, 0);
    }


}

export default ScrollBtn;